import regionConfig from '../config/regionConfig.json'

export const PROPERTY_TYPES = [
  { value: 'byt', label: 'Byty' },
  { value: 'chata', label: 'Chaty' },
  { value: 'dum', label: 'Domy' },
  { value: 'pozemek', label: 'Pozemky' },
  { value: 'komercni', label: 'Komerční' },
  { value: 'ostatni', label: 'Ostatní' },
]

const regionsById = regionConfig.regions.reduce((acc, region) => {
  acc[region.id] = region
  return acc
}, {})

const findRegion = (region) => {
  if (!region) return null

  return regionConfig.regions.find((entry) => {
    return entry.id === String(region).toLowerCase() || entry.value === region || entry.label === region
  })
}

export const getAvailableRegions = (propertyType) => {
  const regionIds = regionConfig.propertyTypeRegions[propertyType] || regionConfig.defaultRegions || []

  return regionIds
    .map((regionId) => regionsById[regionId])
    .filter(Boolean)
    .map(({ value, label, kind }) => ({ value, label, kind }))
}

export const getDefaultRegion = (propertyType, user) => {
  const availableRegions = getAvailableRegions(propertyType)

  // If user has a preferred region, check if it's available for this property type
  if (user?.defaultRegion) {
    const configuredPreference = findRegion(user.defaultRegion)
    const preferredRegion = availableRegions.find((region) => region.value === configuredPreference?.value)
    if (preferredRegion) {
      return preferredRegion.value
    }
  }

  // Preserve the existing fast-lane default when the user has no preference.
  return availableRegions.find((region) => region.value === 'Brno')?.value || availableRegions[0]?.value || 'Brno'
}

export const isValidRegion = (propertyType, region) => {
  return getAvailableRegions(propertyType).some((r) => r.value === region)
}

export const getNotificationRegionOptions = (propertyType = null) => {
  const allowedIds = propertyType
    ? regionConfig.propertyTypeRegions[propertyType] || regionConfig.defaultRegions || []
    : regionConfig.regions.map((region) => region.id)
  const regionIds = allowedIds.filter((regionId) => regionsById[regionId]?.kind === 'quick')

  return regionIds
    .map((regionId) => regionsById[regionId])
    .filter(Boolean)
    .map(({ id, label }) => ({ value: id, label }))
}

export const getRegionLabel = (region) => {
  return findRegion(region)?.label || region
}

export const getPropertyTypeLabel = (type) => {
  const propertyType = PROPERTY_TYPES.find((t) => t.value === type)
  return propertyType?.label || type
}
